module.exports = __webpack_public_path__ + "static/media/kiki_popup.29894aae.png";